<template>
  <div class="container-fluid" style="position: absolute; min-width: 100%; min-height: 100%; max-width: 100%; display: flex; align-items: center;"><!--bg-maintenance-image-->

    <QrCode ref="QrCode" :name="'QrCode'" @onQr="getSerial"/>

    <div class="col-md-6 offset-md-3 col-xs-12 pt-1 pl-0 pr-0">
      <div class="card border-grey border-lighten-3 box-shadow-3 px-0 pl-0">

        <div class="card-header no-border">
          <div class="row">    
            <div class="col-md-12"></div>
          </div>
        </div>

        <div class="card-body">
          <div class="card-block" style="padding: 0 1rem 1rem 1rem;">

            <!-- serial -->
            <div class="row">
              <div class="col-md-8 offset-md-2 mb-1" style="margin-top: 5px">
                <label for="serial">Serial number router</label>
                <div class="input-group" >
                  
                  <input type="text"
                        v-model.trim="$v.serial.$model"
                        :class="{ 'border-danger': $v.serial.$error }"
                        class="form-control border-primary form-control-lg input-lg"
                        id="serial"
                        name="serial"
                        ref="serial"
                  >
                  <!-- <div class="input-group-append">
                    <button type="button" ref="sendSerial" class="btn btn-warning btn-round" @click="showModalQR()" :title=" $t('equipm.hint.scanQr')">
                        <i style="font-size: 1.5rem" class="icon-qrcode"></i>
                    </button>
                  </div> -->
                </div>
                <span v-if="$v.serial.$error" style="color: red">
                  <span class="d-flex" v-if="!$v.serial.required">{{$t('errors.required')}}</span>
                  <span class="d-flex" v-if="!$v.serial.$minLength">Minimal length {{ $v.serial.$params.minLength.min }}</span>
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-8 offset-md-2 mb-1" style="margin-top: 5px">                
                <div class="form-group mb-0">
                    <label for="typeTask">Simcard number PLUS</label>
                    <div class="position-relative">  
                      <input type="text"
                            id="typeTask"
                            class="form-control form-control-lg input-lg border-primary"
                            :class="{ 'border-danger': $v.numberSimPlus.$error }"
                            name="typeTask"
                            v-model.trim="$v.numberSimPlus.$model">
                    </div>
                </div>
                <span v-if="$v.numberSimPlus.$error" style="color: red">
                  <span class="d-flex" v-if="!$v.numberSimPlus.required">{{$t('errors.required')}}</span>
                  <span class="d-flex" v-if="!$v.numberSimPlus.$minLength">Minimal length {{ $v.numberSimPlus.$params.minLength.min }}</span>
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-8 offset-md-2 mb-1" style="margin-top: 5px">                
                <div class="form-group mb-0">
                    <label for="typeTask">Simcard number ORANGE</label>
                    <div class="position-relative">  
                      <input type="text"
                            id="typeTask"
                            class="form-control form-control-lg input-lg border-primary"
                            :class="{ 'border-danger': $v.numberSimORANGE.$error }"
                            name="typeTask"
                            v-model.trim="$v.numberSimORANGE.$model">
                    </div>
                </div>
                <span v-if="$v.numberSimORANGE.$error" style="color: red">
                  <span class="d-flex" v-if="!$v.numberSimORANGE.required">{{$t('errors.required')}}</span>
                  <span class="d-flex" v-if="!$v.numberSimORANGE.$minLength">Minimal length {{ $v.numberSimORANGE.$params.minLength.min }}</span>
                </span>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 d-flex" style="justify-content: center;">
                <button type="button" class="btn btn-lg btn-warning" @click="sendSerial()">
                  Send
                </button>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>       
</template>

<script>
import { required, minLength} from 'vuelidate/lib/validators'

  export default {
      name: "Control",
      components: {},
      data() {
          return {
            serial: null,
            numberSimPlus: null,
            numberSimORANGE: null,
            
            //validation
            errors: [],
            submitStatus: null,
            //validation
          };
        },
        validations: {
          serial:{ required, minLength: minLength(4) },
          numberSimPlus: { required, minLength: minLength(4) },
          numberSimORANGE: { required, minLength: minLength(4) },
        },
        methods: {
          getSerial(serial) {
            if ( this.isValid(serial) ){
              this.serial = serial;
            }
          },
          sendSerial(){
            this.$v.$touch();

            if ( this.$v.serial.$error || this.$v.numberSimPlus.$error || this.$v.numberSimORANGE.$error){
              this.submitStatus = 'ERROR';
              return
            }
            
            let dataRequest = {
              serial: this.serial,
              numberSimPlus: this.numberSimPlus,
              numberSimORANGE: this.numberSimORANGE
            };

            this.makeQuery('/service/addSerialNumber',{dataRequest : dataRequest})
            .then(result => {

              this.serial = null;
              this.numberSimPlus = null;
              this.numberSimORANGE = null;

              this.showNotification('custom-success','Sended','');

              this.$v.$reset();
            })
            .catch(result => {
              this.showNotification('custom-error','Error',result);
            })
              
            
          },
        },
        computed:{
          listLanguages(){
            let arrLang = [];
            for (let i = 0; i < this.$i18n.availableLocales.length; i++) {
              arrLang[this.$i18n.getLocaleMessage(this.$i18n.availableLocales[i]).lang.id] = this.$i18n.availableLocales[i];
            }
            return arrLang;
          },
        },
        components: {},
        mounted () {
          this.$i18n.locale = 'en';

        },
        watch:{},
        created(){}
    }
</script>

<style>
.border-danger{
  border: 3px solid #DA4453 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/addSerial.vue